export default __webpack_public_path__ + "static/media/menu_logo.776d9ef0.png";